import { getMatrixFromXLS } from './utils/getMatrixFromXLS';
import { matrixToBlocks } from './utils/matrixToBlocks';
import { parseBETSurfaceAreaPlot } from './utils/parseBETSurfaceAreaPlot';
import { parseHeader } from './utils/parseHeader';
import { parseSurfaceArea } from './utils/parseSurfaceArea';
import { parseTPlot } from './utils/parseTPlot';
import { parseTPlotReport } from './utils/parseTPlotReport';
import { parseTPlotReportData } from './utils/parseTPlotReportData';

export function betParseGemini(blob) {
  let result = {};
  const matrix = getMatrixFromXLS(blob);
  const blocks = matrixToBlocks(matrix);
  if (blocks.length < 1) {
    throw Error('betParseGemini error: no blocks found');
  }
  if (!blocks[0].header) {
    throw Error('betParseGemini: first block does not contain meta info');
  }
  result.header = parseHeader(blocks[0].header);
  result.surfaceArea = parseSurfaceArea(blocks);
  result.betSurfaceAreaPlot = parseBETSurfaceAreaPlot(blocks);
  result.tPlotReport = parseTPlotReport(blocks);
  result.tPlotReportData = parseTPlotReportData(blocks);
  result.tPlot = parseTPlot(blocks);

  return result;
}
